import { render, staticRenderFns } from "./ReclameAquiAverageMonthlyComplaints.container.vue?vue&type=template&id=7ea6b96b&"
import script from "./ReclameAquiAverageMonthlyComplaints.container.vue?vue&type=script&lang=ts&"
export * from "./ReclameAquiAverageMonthlyComplaints.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports